module.exports = __webpack_public_path__ + "img/022.a4917942.png";